<template>
  <base-modal :open="open" @close="$emit('close')">
    <div v-once>
      <div class="video">
        <iframe class="video" src="https://www.youtube.com/embed/B0fIlEU8kQY" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>

    <div slot="footer">
      <div class="col-xs-8 col-xs-offset-2">
        <button class="btn btn-default" @click="$emit('close')">Close</button>
      </div>
    </div>
  </base-modal>
</template>

<script>
  import BaseModal from 'components/common/modals/BaseModal';

  export default {
    name: 'video-modal',
    props: [
      'open',
    ],
    components: {
      BaseModal,
    },
  };

</script>



// WEBPACK FOOTER //
// VideoModal.vue?0836c7be